import * as React from 'react';
import { useAsync } from '../hooks/useAsync';
// eslint-disable-next-line import/no-cycle
import * as auth from '../services/authService';
import parseJwt from '../utils/jwt';

// return user data from token or API call
async function bootstrapAppData() {
  const token = await auth.getAuthToken();
  if (!token) return null;
  // get user info from jwt token
  const jwtUser = parseJwt(token);
  return jwtUser;
}

const AuthContext = React.createContext();
AuthContext.displayName = 'AuthContext';

function AuthProvider(props) {
  const {
    data: user,
    status,
    error,
    isLoading,
    isIdle,
    isError,
    isSuccess,
    run,
    setData,
  } = useAsync();

  // get user data on app mount ------------------
  React.useEffect(() => {
    const appDataPromise = bootstrapAppData();
    run(appDataPromise);
  }, []);

  const login = (formData) => auth.login(formData).then((loggedUser) => {
    console.log('loggedUser >>> ', loggedUser);
    setData(loggedUser);
  });

  const logout = () => {
    auth.logout();
    setData(null);
  };

  const value = React.useMemo(
    () => ({ user, login, logout }),
    [login, logout, user],
  );

  if (isLoading || isIdle) {
    return <h1>Spinner</h1>;
  }

  if (isError) {
    return <h1>{error}</h1>;
  }

  if (isSuccess) {
    return <AuthContext.Provider value={value} {...props} />;
  }

  throw new Error(`Unhandled status: ${status}`);
}

function useAuth() {
  const context = React.useContext(AuthContext);
  if (context === undefined) {
    throw new Error('useAuth must be used within a AuthProvider');
  }
  return context;
}

export { AuthProvider, useAuth };
